import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

import MetricsEditBaseRoute from 'webapp/routes/metrics/edit/base';

import type { CustomQuery } from 'webapp/models-custom';

export default class MetricsEditBuiltRoute extends MetricsEditBaseRoute<CustomQuery> {
	@service('model-manager/custom-queries')
	declare mmCustomQueriesService: Service.ModelManager.CustomQueries;

	protected readonly notFoundText =
		'Custom metric does not exist or you do not have permissions to customize it.';
	protected readonly billingFeature = BillingFeature.QB;

	override model(params: { query_id: string }): CustomQuery | null {
		return this.mmCustomQueriesService.findModel(params.query_id);
	}

	protected openEditPopup(model: CustomQuery) {
		return this.mmCustomQueriesService.openEditPopup(model, 'metrics');
	}
}
